var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtdInfoClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6301 24.1195C18.7211 24.1195 22.0375 20.8031 22.0375 16.7121C22.0375 12.6211 18.7211 9.30469 14.6301 9.30469C10.5391 9.30469 7.22266 12.6211 7.22266 16.7121C7.22266 20.8031 10.5391 24.1195 14.6301 24.1195Z",
    fill: "#D1D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6301 12.2677V16.7121L17.593 18.1936",
    fill: "#D1D9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4074 22.639C16.4984 22.639 19.8148 19.3226 19.8148 15.2316C19.8148 11.1406 16.4984 7.82422 12.4074 7.82422C8.31641 7.82422 5 11.1406 5 15.2316C5 19.3226 8.31641 22.639 12.4074 22.639Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4074 10.7872V15.2316L15.3704 16.7131",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4074 10.7872V15.2316L15.3704 16.7131M19.8148 15.2316C19.8148 19.3226 16.4984 22.639 12.4074 22.639C8.31641 22.639 5 19.3226 5 15.2316C5 11.1406 8.31641 7.82422 12.4074 7.82422C16.4984 7.82422 19.8148 11.1406 19.8148 15.2316Z",
    stroke: "#4258BF",
    strokeWidth: 1.48148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4451 4.12109C19.7672 5.73841 20.411 6.38847 22.0377 6.71369C20.4107 7.0389 19.7668 7.68896 19.4451 9.30628C19.123 7.68896 18.4792 7.03852 16.8525 6.71369C18.4796 6.38847 19.1234 5.73841 19.4451 4.12109Z",
    fill: "#D1D9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5184 7.23438C21.7117 8.20477 22.098 8.5948 23.074 8.78993C22.0978 8.98506 21.7115 9.37509 21.5184 10.3455C21.3252 9.37509 20.9389 8.98483 19.9629 8.78993C20.9391 8.5948 21.3254 8.20477 21.5184 7.23438Z",
    fill: "#D1D9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtdInfoClockIcon);
export default __webpack_public_path__ + "static/media/ttd-info-clock-icon.19d3b37848079fc94f2167d400751db9.svg";
export { ForwardRef as ReactComponent };